import { scribeHttpV2 } from '@/utils/scribeHTTP';

import { buildDefaultUploadAuthContext } from './upload-auth-context';
import { createRecorderUploaderClient } from './upload-client';
import type { RecorderUploaderResult } from './upload-types';

let singletonClient: ReturnType<typeof createRecorderUploaderClient> | undefined;

function getSingletonClient(): ReturnType<typeof createRecorderUploaderClient> {
  if (!singletonClient) {
    singletonClient = createRecorderUploaderClient({
      http: scribeHttpV2,
      buildAuthContext: buildDefaultUploadAuthContext,
    });
  }
  return singletonClient;
}

export const recorderUploaderClient = {
  uploadNamed(sessionId: string, name: string): Promise<RecorderUploaderResult> {
    return getSingletonClient().uploadNamed(sessionId, name);
  },
  resumePolling(sessionId: string, recordingId: string): Promise<RecorderUploaderResult> {
    return getSingletonClient().resumePolling(sessionId, recordingId);
  },
  retryUpload(sessionId: string): Promise<RecorderUploaderResult> {
    return getSingletonClient().retryUpload(sessionId);
  },
  cancelPolling(sessionId: string): void {
    getSingletonClient().cancelPolling(sessionId);
  },
};
